import { render, staticRenderFns } from "./ButtonToolbar.vue?vue&type=template&id=15679ca0&scoped=true"
import script from "./ButtonToolbar.vue?vue&type=script&lang=js"
export * from "./ButtonToolbar.vue?vue&type=script&lang=js"
import style0 from "./ButtonToolbar.vue?vue&type=style&index=0&id=15679ca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15679ca0",
  null
  
)

export default component.exports